import { Col, Divider, Row, Avatar } from 'antd'
import Flex from 'components/Flex'
import {
  AddressNew,
  Condition,
  Container1,
  Content,
  Editor,
  EditorContent,
  ExtraPadding,
  FlexContain,
  FlexContain1,
  FlexWrap,
  GrayText,
  GrayTextSmall,
  InfoText,
  LeftCol,
  Name1,
  PopHeading,
  PopSubHeading,
  ShowMoreText,
  SkillBox,
  SkillList,
  SubBold,
  SubtitleLarge,
  SubtitleMedium,
  SubtitleSmall,
  TextWithIcon,
  TitleMedium,
  VerticalDivider,
  VerticalDividerMax,
  YellowBox,
  AndDivision,
} from 'modules/ViewRole/Style/style'
import { toWords } from 'number-to-words'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import CandidatesIcon from '../../../components/icons/CandidatesIcon'
import SuitCaseIcon from 'components/icons/SuitCaseIcon'
import CustomTag from 'components/CustomTag'
import AlarmOn from 'components/icons/Alarm_On'

import PaymentIcon from 'components/icons/PaymentIcon'
import Moment from 'moment'
import { COLORS } from 'theme'

import { formatNumber } from 'utils/formatNumber'
import SkillBasedRoleDrawer from '../../Roles/Style/SkillBasedRoleDrawer'

import WorkExperienceDrawer from 'modules/Resume/DrawerComponents/ProjectDetails/WorkExperienceDrawer'

import { checkJobCategory } from '../../../utils/const'
import { toCamelCase } from '../../../utils/helpers'
import { ShowDiv } from '../../ViewRole/Style/style'
import {
  TextMedium1,
  TagLebelDiv,
  RightDiv,
  JDDescription,
  StyledCardDiv,
  StyledImg,
  StyledH2,
  AdjustIcon,
  StyledDelete,
  ButtonDiv,
  RightDiv1,
  CompensationWrapper,
  CompensationText,
  CompensationAmount,
  CompensationBreakup,
} from 'modules/ViewSingleRole/Style/style'
import { CTCDiv, RightDivStatus1, CTCRow } from 'modules/Roles/Style/style'
import CapIcon from 'components/icons/CapIcon'
import CustomSteps from 'modules/ViewSingleRole/Style/CustomSteps'
import FileIcon from 'components/icons/FileIcon'
import DownArrowIcon from 'components/icons/DownArrowIcon'

const JobDescription = ({
  viewRoleData,
  collegeData,
  getRoleFloatDetails,
  getEligibleDetails,
  getFunctionsList,
  functionsList,
  updateRoleFloatDetails,
  UpdatedSkills,
  studentDetails,
  updateStudentData,
  getListOfSkills,
  onApplyClick,
  roleTypewithComp,
  corporateIds
}) => {
  const numericToWords = number => {
    // Convert the numeric value to words
    const words = toWords(number)

    // Capitalize the first letter for consistency
    return words.charAt(0).toUpperCase() + words.slice(1)
  }

  let mandatorySkillNames = viewRoleData?.role?.mandatorySkillNames ?? null
  const [loading, setLoading] = useState(false)
  const [roleDrawer, setRoleDrawer] = useState(false)

  const selected = {}

  const [workExperienceDrawer, setWorkExperienceDrawer] = useState(false)
  const listOfStudentSkills = []
  const [expanded, setExpanded] = useState(false)

  const contentHeight = useRef(null)

  useEffect(() => {
    if (contentHeight.current && contentHeight.current.clientHeight > 250) {
      setExpanded(false)
    }
  }, [])

  const [completedStep, setCompletedStep] = useState(-1)
  const [completStedepStatus, setCompletStedepStatus] = useState('')
  const [stepsData, setStepsData] = useState([])
  const [showAll, setShowAll] = useState(false)
  let displayedIntegrations = 0

  useEffect(() => {
    console.log('viewRoleData changed:', viewRoleData)
    console.log('completedStep:', completedStep)
    console.log('completStedepStatus:', completStedepStatus)
  }, [viewRoleData, completedStep, completStedepStatus])

  useEffect(() => {
    if (viewRoleData?.role) {
      // Update steps data
      if (viewRoleData.role.interviewWorkFlow?.rounds) {
        const newStepsData = viewRoleData.role.interviewWorkFlow.rounds.map(
          (round, index) => ({
            key: index,
            activeKey: index,
            roundNumber: `Round ${index + 1}`,
            roundName: round?.name,
          })
        )
        setStepsData(newStepsData)
      }

      // Update step status
      if (viewRoleData.role.driveRoleCandidateMap?.[0]) {
        const candidateMap = viewRoleData.role.driveRoleCandidateMap[0]
        const currentStage = candidateMap.stage
        const currentStatus = candidateMap.status

        setCompletStedepStatus(currentStatus || '')

        if (currentStage && viewRoleData.role.interviewWorkFlow?.rounds) {
          const stageIndex = viewRoleData.role.interviewWorkFlow.rounds.findIndex(
            x => x.name === currentStage
          )
          setCompletedStep(stageIndex !== -1 ? stageIndex : -1)
        }
      } else {
        // Reset states if no candidate map
        setCompletStedepStatus('')
        setCompletedStep(-1)
      }
    }
  }, [viewRoleData])

  const eligibleList = useSelector(
    state => state?.rolesListData.eligibleDetails
  )
  const roleFloatList = useSelector(
    state => state?.rolesListData.roleFloatDetails
  )

  const checkDate = date => {
    return Moment(date).format('DD/MM/YYYY')
  }

  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const groupedEducations = roleData => {
    let groupedDatas = roleData?.role?.degreeStreamMap?.reduce(
      (acc, education) => {
        const degreeShortForm = education?.degree?.shortForm
        const streamName = education?.stream?.name

        if (!acc.hasOwnProperty(degreeShortForm)) {
          acc[degreeShortForm] = []
        }

        acc[degreeShortForm].push(streamName)

        return acc
      },
      {}
    )
    return groupedDatas
  }

  const renderContent = roleData => {
    let content = []
    if (groupedEducations(roleData)) {
      Object.entries(groupedEducations(roleData)).forEach(
        ([degree, streamNames]) => {
          content.push(
            <ExtraPadding key={degree}>
              <SubBold>{degree}</SubBold>
              <br />
              {streamNames.join(', ')}
              <br />
            </ExtraPadding>
          )
        }
      )
    }
    return content
  }

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  const totalIntegrations = viewRoleData?.role?.eligibilityCriteria?.reduce(
    (count, item) => {
      return (
        count +
        item?.qualification?.reduce((subCount, qual) => {
          return (
            subCount +
            item?.selected?.[qual]?.reduce((subSubCount, subitem) => {
              return subitem.isAllDegree
                ? subSubCount
                : subSubCount +
                (subitem?.streams?.reduce((streamCount, stream) => {
                  return (
                    streamCount + (stream?.specialisations?.length || 1)
                  )
                }, 0) || 1)
            }, 0)
          )
        }, 0)
      )
    },
    0
  )

  const showItemCount = showAll ? totalIntegrations : 5
  console.log(showItemCount, displayedIntegrations)
  const getCategoryDetails = (minCompensation, maxCompensation) => {
    if (roleTypewithComp?.length === 0 || viewRoleData?.role?.jobCategory != "PLACEMENT") {
      return { orderNo: null, name: null } // Return null for both if no roleTypewithComp? exist
    }

    let matchingCategory = roleTypewithComp?.find(
      category =>
        maxCompensation >= category.minCTC &&
        maxCompensation <= (category.maxCTC || Number.MAX_SAFE_INTEGER)
    )

    if (matchingCategory) {
      return { orderNo: matchingCategory.orderNo, name: matchingCategory.name }
    }

    return { orderNo: null, name: null }
  }
  const categoryDetails = getCategoryDetails(
    viewRoleData?.role?.minCompensation,
    viewRoleData?.role?.maxCompensation
  )

  function formatCurrency(amount, keyData) {
    if (amount < 100000) {
      // For amounts less than 1 lakh, convert to K (thousands)
      return `${(amount / 1000).toFixed(2)}K ${keyData}`;
    } else {
      // For amounts equal to or more than 1 lakh, convert to L (lakhs)
      return `${(amount / 100000).toFixed(2)} L${keyData == "PM" ? " PM" : "PA"}`;
    }
  }
  const downloadFileLocal = async file => {
    try {
      const response = await fetch(file.fileUrl)
      if (!response.ok) {
        throw new Error('Failed to download file')
      }
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = file.fileName
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }
  const getOrderBasedColor = orderNo => {
    switch (orderNo) {
      case 1:
        return {
          color: '#000000',
          borderColor: '#CCCCCC',
          background: '#CCCCCC33', // 20% opacity of #CCCCCC
        }
      case 2:
        return {
          color: '#000000',
          borderColor: '#97CADB',
          background: '#97CADB33', // 20% opacity of #97CADB
        }
      case 3:
        return {
          color: '#000000',
          borderColor: '#B5A3F7',
          background: '#B5A3F733', // 20% opacity of #B5A3F7
        }
      case 4:
        return {
          color: '#000000',
          borderColor: '#E1A7BA',
          background: '#E1A7BA33', // 20% opacity of #E1A7BA
        }
      case 5:
        return {
          color: '#000000',
          borderColor: '#F29F05',
          background: '#F29F0533', // 20% opacity of #F29F05
        }
      case 6:
        return {
          color: '#000000',
          borderColor: '#F25C05',
          background: '#F25C0533', // 20% opacity of #F25C05
        }
      case 7:
        return {
          color: '#000000',
          borderColor: '#72B06F',
          background: '#72B06F33', // 20% opacity of #72B06F
        }
      case 8:
        return {
          color: '#000000',
          borderColor: '#4C1D91',
          background: '#4C1D9133', // 20% opacity of #4C1D91
        }
      case 9:
        return {
          color: '#000000',
          borderColor: '#02457A',
          background: '#02457A33', // 20% opacity of #02457A
        }
      case 10:
        return {
          color: '#000000',
          borderColor: '#595F33',
          background: '#595F3333', // 20% opacity of #595F33
        }
      default:
        return {
          // Default style for unmatched cases
          color: '#000000',
          borderColor: '#DBDBDB',
          background: '#DBDBDB33', // 20% opacity of #DBDBDB
        }
    }
  }
  const splitDate = () => {
    let date = {
      minYear: '0',
      maxYear: '0',
      minMonth: '0',
      maxMonth: '0',
    }
    if (viewRoleData?.role?.yearOfExperience?.length > 1) {
      let min = String(viewRoleData?.role?.yearOfExperience?.[0])?.split('.')
      let max = String(viewRoleData?.role?.yearOfExperience?.[1])?.split('.')
      if (min?.length) {
        date.minYear = min?.[0] ?? 0
        date.minMonth = min?.[1] ?? 0
      }
      if (max?.length) {
        date.maxYear = max?.[0] ?? 0
        date.maxMonth = max?.[1] ?? 0
      }
    }
    return date
  }
  const date = splitDate()
  const fixedCTC = Number(viewRoleData?.role?.minCompensation || 0)
  const getCompensationText = () => {
    const min = Number(viewRoleData?.role?.minCompensation)
    const max = Number(viewRoleData?.role?.maxCompensation)

    if (min === max) {
      return `₹ ${formatNumber(min)}`
    }

    if (min && max) {
      return `₹ ${formatNumber(min)} - ₹ ${formatNumber(max)}`
    }

    return `₹ ${formatNumber(max || min)}`
  }
  const hasVariablePay =
    viewRoleData?.role?.ctcType === 'FIXED_VARIABLE'
  return (
    <>
      <Row>
        <LeftCol span={24}>
          <TextMedium1>{viewRoleData?.role?.tittle}</TextMedium1>

          <FlexContain centerVertically>
            <Avatar src={<CandidatesIcon />} />
            &nbsp;&nbsp;
            <TagLebelDiv>
              {/* {viewRoleData?.role?.rolePublishedBy === 'INSTITUTE'
                ? checkJobCategory(viewRoleData?.role?.jobCategory)
                : checkJobTypeLevel(
                    viewRoleData?.role?.jobTypeLevels,
                    viewRoleData?.role?.yearOfExperience
                  )} */}
              {checkJobCategory(viewRoleData?.role?.jobCategory)}
            </TagLebelDiv>
            <Avatar src={<CapIcon />} />
            &nbsp;&nbsp;
            <TagLebelDiv>
              {viewRoleData?.role?.jobTypeLevels?.[0] == 'ENTRY' ||
                viewRoleData?.role?.jobTypeLevels?.[0] == 'INTERN'
                ? 'Freshers'
                : viewRoleData?.role?.jobTypeLevels?.[0] == 'BOTH'
                  ? 'Both'
                  : viewRoleData?.role?.jobTypeLevels?.[0] == 'EXPERIENCED'
                    ?
                    <>
                      {'Exp. ( ' +
                        (date?.minYear +
                          (Number(date?.minYear) <= 1
                            ? 'yr   '
                            : ' yrs   ')) +
                        (date?.minMonth + 'mths   ')}
                      {viewRoleData?.role?.yearOfExperience?.[1] &&
                        '-' +
                        (date?.maxYear +
                          (Number(date?.maxYear) <= 1
                            ? 'yr  '
                            : ' yrs  ')) +
                        date?.maxMonth +
                        'mths )'}
                    </>

                    : ''}
            </TagLebelDiv>
            <Avatar src={<AlarmOn />} />
            &nbsp;&nbsp;
            <TagLebelDiv>
              {viewRoleData?.role?.jobType === 'FULL_TIME'
                ? 'Full Time'
                : 'Part Time'}
              {viewRoleData?.role?.jobCategory === 'INTERNSHIP' &&
                Number(viewRoleData?.role?.internshipDuration) &&
                Number(viewRoleData?.role?.internshipDuration) !== 0
                ? ' (' +
                (viewRoleData?.role?.jobCategory === 'INTERNSHIP'
                  ? `${Number(viewRoleData?.role?.internshipDuration) >= 30
                    ? (Number(viewRoleData?.role?.internshipDuration) /
                      30) %
                      1 ===
                      0
                      ? `${Number(
                        viewRoleData?.role?.internshipDuration
                      ) / 30
                      } Month${Number(
                        viewRoleData?.role?.internshipDuration
                      ) /
                        30 ===
                        1
                        ? ''
                        : 's'
                      }`
                      : `${(
                        Number(
                          viewRoleData?.role?.internshipDuration
                        ) / 30
                      ).toFixed(1)} Month${(
                        Number(
                          viewRoleData?.role?.internshipDuration
                        ) / 30
                      ).toFixed(1) === '1.0'
                        ? ''
                        : 's'
                      }`
                    : Number(viewRoleData?.role?.internshipDuration) < 30
                      ? `${Number(
                        viewRoleData?.role?.internshipDuration
                      )} Day${Number(
                        viewRoleData?.role?.internshipDuration
                      ) === 1
                        ? ''
                        : 's'
                      }`
                      : `${Number(
                        viewRoleData?.role?.internshipDuration
                      )} Day${Number(
                        viewRoleData?.role?.internshipDuration
                      ) === 1
                        ? ''
                        : 's'
                      }`
                  }`
                  : viewRoleData?.role?.jobCategory === 'GIGS'
                    ? // <>

                    `${viewRoleData?.role?.gigsDuration?.[0]?.toString()}` +
                    ' yrs' +
                    `${viewRoleData?.role?.gigsDuration?.[1] &&
                    '-' +
                    viewRoleData?.role?.gigsDuration?.[1]?.toString() +
                    ' yrs '
                    }`
                    : '') +
                ') '
                : ''}
              {viewRoleData?.role?.employmentType == 'ONROLL'
                ? '(OnRoll)'
                : '(Contract)'}
            </TagLebelDiv>
            <Avatar src={<SuitCaseIcon />} />
            <TagLebelDiv>
              {viewRoleData?.role?.workStyle === 'REMOTE'
                ? 'Remote'
                : viewRoleData?.role?.workStyle === 'ONSITE'
                  ? 'Onsite'
                  : viewRoleData?.role?.workStyle === 'HYBRID'
                    ? 'Hybrid'
                    : ''}
            </TagLebelDiv>
          </FlexContain>
          <FlexContain1 centerVertically>
            <CompensationWrapper>
              <Avatar src={<PaymentIcon />} />
              <CompensationText>
                {(viewRoleData?.role?.stipend === false &&
                  viewRoleData?.role?.minCompensation == 0 &&
                  viewRoleData?.role?.maxCompensation == 0) ? (
                  <span>No Stipend</span>
                ) : (
                  <>
                    <CompensationAmount>
                      {viewRoleData?.role?.CTCPeriod === 'ANNUALLY'
                        ? 'Annually'
                        : viewRoleData?.role?.CTCPeriod === 'MONTHLY'
                          ? 'Monthly'
                          : viewRoleData?.role?.CTCPeriod === 'WEEKLY'
                            ? 'Weekly'
                            : viewRoleData?.role?.CTCPeriod === 'DAILY'
                              ? 'Daily'
                              : viewRoleData?.role?.CTCPeriod === 'HOURLY'
                                ? 'Hourly'
                                : ''}{' '}
                      {getCompensationText()}
                    </CompensationAmount>

                    {hasVariablePay ? (
                      <CompensationBreakup>
                        (Fixed+Variable)
                      </CompensationBreakup>
                    ) : (
                      <span>(Fixed)</span>
                    )}
                  </>
                )}
              </CompensationText>
            </CompensationWrapper>
          </FlexContain1>
          {/* <RightDiv1  orderNo={corporateIds?.includes(viewRoleData?.role?.corporate?.id || viewRoleData?.role?.company?.id) && viewRoleData?.role?.jobCategory === "PLACEMENT"  ? 11 :categoryDetails.orderNo}>
              <Flex centerVertically spaceBetween>
                <CTCDiv>
                  <Avatar
                    src={
                      <PaymentIcon
                        color={
                          corporateIds?.includes(viewRoleData?.role?.corporate?.id || viewRoleData?.role?.company?.id) && viewRoleData?.role?.jobCategory === "PLACEMENT" ? '#DBDBDB' :
                          getOrderBasedColor(categoryDetails.orderNo)
                            .borderColor
                        }
                      />
                    }
                    style={{ paddingTop: '7px' }}
                  />
                  {(viewRoleData?.role?.stipend === false && viewRoleData?.role?.rolePublishedBy === 'INSTITUTE')  ||
                  (viewRoleData?.role?.minCompensation == 0 &&
                    viewRoleData?.role?.maxCompensation == 0) ? (
                    <span>No Stipend</span>
                  ) : (
                    <>
                      &nbsp; {viewRoleData?.role?.jobCategory === "INTERNSHIP" && viewRoleData?.role?.minCompensation != 0 &&
                      viewRoleData?.role?.maxCompensation != 0 ? "Stipend" : "CTC"}{' '}
                      <span>
                        &nbsp;
                        {viewRoleData?.role?.minCompensation ===
                        viewRoleData?.role?.maxCompensation ? (
                          <span>
                            {`₹${formatCurrency(
                              Number(viewRoleData?.role?.minCompensation) , viewRoleData?.role?.CTCPeriod === 'MONTHLY'
                              ? 'PM'
                              : 'PA'
                            )}`}
                         
                          </span>
                        ) : (
                          <span>
                            {`₹${formatCurrency(
                              Number(viewRoleData?.role?.minCompensation) , viewRoleData?.role?.CTCPeriod === 'MONTHLY'
                              ? 'PM'
                              : 'PA'
                            )} - ₹${formatCurrency(
                              Number(viewRoleData?.role?.maxCompensation) , viewRoleData?.role?.CTCPeriod === 'MONTHLY'
                              ? 'PM'
                              : 'PA'
                            )}`}
                           
                          </span>
                        )}
                      </span>
                    </>
                  )}
               <span>   {viewRoleData?.role?.ctcType &&
                        ' (' +
                          (viewRoleData?.role?.ctcType === 'FIXED_VARIABLE'
                            ? 'Fixed+Variable'
                            : viewRoleData?.role?.ctcType === 'FIXED'
                            ? 'Fixed'
                            : '') +
                          ') '} </span>
                </CTCDiv>
                <Flex flexEnd>
                {corporateIds?.includes(viewRoleData?.role?.corporate?.id || viewRoleData?.role?.company?.id) && viewRoleData?.role?.jobCategory === "PLACEMENT" && (
                  <RightDivStatus1 color={'#D5D5D5'} border={'#000000'}>
                    Excep. Brand
                  </RightDivStatus1>
                )}
                {!corporateIds?.includes(viewRoleData?.role?.corporate?.id || viewRoleData?.role?.company?.id) && categoryDetails?.name && (
                  <RightDivStatus1
                    color={
                      getOrderBasedColor(categoryDetails.orderNo).borderColor
                    } // Assuming getOrderBasedColor returns the style based on the orderNo
                  >
                    {categoryDetails?.name}
                  </RightDivStatus1>
                )}
                </Flex>
              </Flex>
            </RightDiv1>&nbsp;&nbsp;&nbsp;&nbsp; */}
          <Divider style={{ margin: '15px 0px' }} />
          <JDDescription>Job Description</JDDescription>
          <Editor>
            <EditorContent
              dangerouslySetInnerHTML={{
                __html: viewRoleData?.role?.description || '',
              }}
            />
          </Editor>

          {viewRoleData?.role?.ctcType === 'FIXED_VARIABLE' && (
            <div>
              {(() => {
                const fixed = Number(viewRoleData?.role?.minCompensation || 0);
                const variable = viewRoleData?.role?.variableAmount;
                const hasVariable =
                  variable !== null &&
                  variable !== undefined &&
                  `${variable}`.trim() !== '';

                if (viewRoleData?.role?.ctcType === 'FIXED_VARIABLE' && hasVariable) {
                  return (
                    <div>
                      <JDDescription mTop="10px" mBottom="5px">
                        Fixed+Variable
                      </JDDescription>
                      <EditorContent
                        style={{ marginTop: '1em', wordBreak: 'break-word' }}
                      >{variable}</EditorContent>
                    </div>
                  );
                }
                return null;
              })()}
            </div>
          )}

          {viewRoleData?.role?.additionalBenefits?.length > 0 && (
            <>
              <JDDescription>Additional Benefits</JDDescription>
              <Editor>
                <EditorContent
                  dangerouslySetInnerHTML={{
                    __html: viewRoleData?.role?.additionalBenefits || '',
                  }}
                />
              </Editor>
            </>
          )}
          {viewRoleData?.role?.bondType?.length > 0 && (
            <>
              <JDDescription>Bond</JDDescription>
              <Editor>
                <EditorContent
                  dangerouslySetInnerHTML={{
                    __html: viewRoleData?.role?.bondType || '',
                  }}
                />
              </Editor>
            </>
          )}
          {viewRoleData?.role?.interviewWorkFlow?.rounds?.length && (
            <>
              <JDDescription>Evaluation Process</JDDescription>
              <br></br>
              <CustomSteps
                current={completedStep}
                currentStatus={completStedepStatus}
                steps={stepsData}
              />
            </>
          )}

          {viewRoleData?.role?.jobRoleDocs?.filter(Boolean)?.length > 0 && (

            <div style={{ marginTop: "20px" }}>
              <JDDescription>Attached File</JDDescription>
              {viewRoleData?.role?.jobRoleDocs?.filter(Boolean)?.map((item, key) => (
                <StyledCardDiv key={key + 'role'} width={"90%"}>
                  <StyledImg>
                    <AdjustIcon alignContent>
                      <FileIcon />
                    </AdjustIcon>
                    <Flex gap="5px">
                      <StyledH2>
                        {item?.fileName}
                      </StyledH2>
                      {/* <StyledH2>{item.fileSize}</StyledH2> */}
                    </Flex>
                  </StyledImg>
                  <Flex>
                    <StyledDelete>
                      <ButtonDiv>
                        <DownArrowIcon
                          onClick={() => downloadFileLocal(item)}
                        />
                      </ButtonDiv>
                    </StyledDelete>
                  </Flex>
                </StyledCardDiv>
              ))}
            </div>
          )}

        </LeftCol>
      </Row>

      {roleDrawer && (
        <SkillBasedRoleDrawer
          setRoleDrawer={setRoleDrawer}
          roleDrawer={roleDrawer}
          eligibleList={eligibleList}
          roleFloatList={roleFloatList}
          setWorkExperienceDrawer={setWorkExperienceDrawer}
          getFunctionsList={getFunctionsList}
          updateRoleFloatDetails={updateRoleFloatDetails}
          getEligibleDetails={getEligibleDetails}
          UpdatedSkills={UpdatedSkills}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
          onApplyClick={onApplyClick}
        />
      )}

      {workExperienceDrawer && (
        <WorkExperienceDrawer
          drawerStatus={workExperienceDrawer}
          setdrawerStatus={setWorkExperienceDrawer}
          studentFormData={studentDetails}
          updateStudentData={updateStudentData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          listOfStudentSkills={listOfStudentSkills}
          roleDrawer={roleDrawer}
          setRoleDrawer={setRoleDrawer}
          getEligibleDetails={getEligibleDetails}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
        />
      )}
    </>
  )
}

export default JobDescription
